import React, { useCallback } from 'react';
import { Box, Button } from '@mui/material';
import styles from './ForgetEmail.module.css';
import { CommonPageStep } from '../..';
import { setAppPageStep } from '../../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../../store/store';
import {
  ForgetEmailElement,
  ForgetEmailElementInterface,
} from '../ForgetEmailElement';

export const MobileView = (): JSX.Element => {
  const forgetEmailElement: ForgetEmailElementInterface = ForgetEmailElement();
  return (
    <React.Fragment>
      <Box className={styles.mainGroupBox}>
        <Box className={styles.mainGroupTitleBox}>
          <img
            id="login-main-back-button"
            alt=""
            src="assets/login/login-main-back-button.svg"
            onClick={(): void => {
              window.location.href = '/ForgetPassword';
            }}
          />
          <span className={styles.mainGroupTitle}>Forget Email</span>
        </Box>
        <Box style={{ marginTop: '26px' }}>
          <Box className={styles.mainGroupBoxDescription}>
            <span
              className={styles.mainGroupBoxDescriptionText}
            >{`Don't worry. We can fix this!`}</span>
          </Box>
          <Box className={styles.mainGroupBoxDescription}>
            <span
              className={styles.mainGroupBoxDescriptionText}
            >{`Contact us to retrieve your account.`}</span>
          </Box>
        </Box>
        <Box className={styles.mainGroupCenter}>
          <Box className={styles.mainGroupForgetEmailBox}>
            <Box className={styles.contactUsGroupBox}>
              <Box className={styles.contactUsImageGroupBox}>
                <img
                  style={{ maxWidth: '100%', width: '94px' }}
                  id="contact-us-group-bobo"
                  alt=""
                  src="assets/common/contact-us-group-bobo.png"
                />
              </Box>
              <Box className={styles.contactUsButtonGroupBox}>
                <Button
                  variant="contained"
                  fullWidth={true}
                  sx={{ width: 'inherite' }}
                  endIcon={
                    <img
                      id="whatsapp-icon"
                      alt=""
                      src="assets/common/whatsapp-icon.svg"
                    />
                  }
                  onClick={forgetEmailElement.contactUsButtonClickHandler}
                >
                  Contact Us
                </Button>
                <Button
                  variant="contained"
                  fullWidth={true}
                  sx={{ width: 'inherite' }}
                  endIcon={
                    <img
                      id="mail-icon"
                      alt=""
                      src="assets/common/mail-icon.svg"
                    />
                  }
                  onClick={forgetEmailElement.emailUsButtonClickHandler}
                >
                  Email
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <header className={styles.headerGroup} id="common-navi-bar">
        <img
          className={styles.bbaLogoIcon}
          id="entry-header"
          alt=""
          src="assets/common/bba-logo.svg"
        />
      </header>
    </React.Fragment>
  );
};
